
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Classical Conclave</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm raagas-urvashi section-banner-bg-1">
    <div class="container">
        <div class="row justify-content-center align-items-center">

            <div class="sec-title text-center">
                <h2>Raagas To Riches By <span > Urvashi Shah 2022 </span></h2>
            </div>

            <div class="row">
                <div class="col-lg-8">
                    <div class=" text-justify">
                        <p>Urvashi Shah realized that music is her true calling very early in life. To give her musical
                            leanings a tangible form, she spent 7 years learning under the tutelage of Mrs. Meera
                            Banerjee of the Patiala Gharana, in Kolkata.</p>
                        <p>Having relocated to Pune in 1998, she continued her pursuit for excellence in Indian
                            Classical singing by learning under the guidance of Dr. Veena Sahastrabuddhe of the Gwalior
                            Gharana from 1999 till 2014.</p>
                        <p>Urvashi also gained invaluable insights into music from Pandit Mohan Karve of the Gwalior
                            Gharana, under whose tutelage she learnt from 2001 to 2005.</p>
                        <p>A much sought-after classical singer in Pune today, Urvashi also holds a BA in Political
                            Science from St. Xavier's College, Kolkata. She then attained a Sangeet Visharad and Sangeet
                            Alankar from the Gandharva Mahavidyalaya, Meeraj.</p>
                        <p><b>Let’s meet you then.</b></p>
                        <p><b>Topic: Raagas to Riches </b></p>
                        <p><b>Date – 21st May 2022 Saturday </b></p>
                        <p><b>Time – 6.30 PM </b></p>
                        <p><b>Venue: Tamarind Hall, Chitnavis Centre, Nagpur </b></p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="image-effect-2">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/raagas-urvashi-1.webp"
                            alt="GHRSCF" style="width: 100%;">
                    </div>
                </div>
            </div>
        </div>

        <div class="border-line-sm"></div>
        <div class="row">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Media Coverage</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <a href="media#media_classical" class="btn button--effect-1"><span>
                                    View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                    <iframe style="width: 100%; height: 230px;"
                        src="https://drive.google.com/file/d/1wDIzLGKC0v7epCHjOiUBbOxKFQTcyBag/preview"></iframe>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Photos</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <a href="photogallery#raagas-urvashi" class="btn button--effect-1"><span>
                                    View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi2.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi2.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi2.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi3.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi3.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi3.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi4.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi4.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi4.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi5.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi5.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi5.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi6.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi6.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi6.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi7.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi7.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/raagas-urvashi7.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>


                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
